export enum MplOrderStatus {
    SHIPMENT_AWAITING = 'SHIPMENT_AWAITING',
    SHIPMENT_POSTED = 'SHIPMENT_POSTED',
    SHIPMENT_CLOSED = 'SHIPMENT_CLOSED',
}
